import path from "node:path"
import {fileURLToPath} from "node:url"

import fsp from "@absolunet/fsp"
import createDebug from "debug"
import execa from "execa"
import firstExistingPath from "first-existing-path"
import tempy from "tempy"

import {isEmpty} from "./esm/has-content.js"

const debug = createDebug(process.env.REPLACE_PKG_NAME)

async function findModules() {
  const findModulesJobs = [
    "jsdoc-export-default-interop/dist/index.js",
    "jsdoc-babel/lib/index.js",
  ].map(async file => {
    const dirName = path.dirname(fileURLToPath(import.meta.url))
    const possiblePaths = [
      path.resolve("node_modules", file),
      path.resolve(dirName, "node_modules", file),
    ]
    const foundFile = await firstExistingPath(possiblePaths)
    if (!foundFile) {
      throw new Error(`Could not find ${file}. Searched in: ${possiblePaths}`)
    }
    debug("Found file", foundFile)
    return foundFile
  })

  const [jsdocExportDefaultInteropPath, jsdocBabelPath] = await Promise.all(findModulesJobs)

  return {
    jsdocExportDefaultInteropPath,
    jsdocBabelPath,
  }
}

/**
 * @param {import("src").Context} context
 * @return {Promise<string>}
 */
async function getJsdocConfig(context) {
  const modulePaths = await findModules()
  const jsdocConfig = {
    opts: {
      recurse: true,
      encoding: "utf8",
    },
    sourceType: "module",
    plugins: [],
  }
  const babel = true
  if (babel) {
    jsdocConfig.plugins.unshift(modulePaths.jsdocBabelPath)
    jsdocConfig.babel = {
      caller: {
        name: "tldw",
      },
      cwd: process.cwd(),
      root: process.cwd(),
      comments: true,
      envName: "development",
    }
  }
  return jsdocConfig
}

/**
 * @param {import("src").Context} context
 * @return {Promise<string>}
 */
export default async context => {
  try {
    const jsdocConfig = await getJsdocConfig(context)
    const jsdocConfigFile = await tempy.file({extension: "json"})
    debug(`JSDoc config written to: ${jsdocConfigFile}`)
    await fsp.outputJson(jsdocConfigFile, jsdocConfig)
    const jsdocToMarkdownArgs = ["jsdoc-to-markdown", "--files", context.args.sourceGlob, "--example-lang", "javascript", "--configure", jsdocConfigFile]
    const result = await execa("npx", jsdocToMarkdownArgs)
    debug(`Executed: ${result.command}`)
    debug(`= ${result.exitCode}`)
    if (isEmpty(result.stdout)) {
      return null
    }
    const apiMarkdown = result.stdout.replace(/## \S+/s, "## Reference")
    return apiMarkdown
  } catch (error) {
    console.warn("Could not run JSDoc")
    console.warn(error)
    return null
  }
}